import superagent from 'superagent'

import { API_HOST, SESSION_ID } from './utils'


const API_PATH = `${API_HOST}/api`
export const WEB_HOST = API_HOST

export function windowRedirect(pathname, cb) {
  window.location = `${WEB_HOST}${pathname}`
  cb && cb()
}

export async function fetchProduct(productId) {
  try {
    const { body } = await superagent.get(`${API_PATH}/products/${productId}`)
    return body
  } catch (e) {
    return null
  }
}

export async function fetchSkuAvs() {
  try {
    const { body } = await superagent.get(`${API_PATH}/sku-availabilities`)
    return body
  } catch (e) {
    return null
  }
}

export async function fetchSkuAvsCount(skuId, dateRange) {
  try {
    const { body } = await superagent.get(`${API_PATH}/skus/${skuId}/availability/count?dateFrom=${dateRange.dateFrom}&dateTo=${dateRange.dateTo}`)
    return body
  } catch (e) {
    return null
  }
}

export async function fetchSkusByProduct(productId) {
  try {
    const { body } = await superagent.get(`${API_PATH}/skus/by-product/${ productId}`)
    return body
  } catch (e) {
    return null
  }
}

export async function fetchSkuAvailabilitiesDistribution(skuId) {
  try {
    const { body } = await superagent.get(`${API_PATH}/skus/${ skuId }/availability/distribution`)
    return body
  } catch (e) {
    return null
  }
}

export async function fetchRental({ fromDate, toDate, product_variation, price }) {
  const payload = {
    fromDate,
    toDate,
    product_variation,
    price,
  }
  try {
    const { body } = await superagent
      .post(`${API_PATH}/rentals`)
      .send(payload)
    return body
  } catch (e) {
    console.error(e)
  }
}


export async function addOrderRental({ rental, order }) {
  try {
     if (!order) {
       const { body } = await superagent.post(`${API_PATH}/orders`).send({
         rentals: [rental],
         price: rental.price,
       })
       return body
     } else {
       const rentals = [...order.rentals, rental]
       const { body } = await superagent.put(`${API_PATH}/orders/${order.id}`).send({
         rentals: [...order.rentals, rental],
         price: rentals.reduce((s, r) => s + r.price, 0),
       })
       return body
     }
  } catch (e) {
    console.error(e)
  }
}

export async function removeOrderRental(orderId, rentalId) {
  try {
    const { body: order } = await superagent.get(`${API_PATH}/orders/${orderId}`)
    order.rentals = order.rentals.filter(r => r.id !== rentalId)
    await superagent.put(`${API_PATH}/orders/${orderId}`).send({
      rentals: order.rentals,
      price: order.rentals.reduce((s, r) => s + r.price, 0),
    })
    const { body: newOrder } = await superagent.get(`${API_PATH}/orders/${orderId}`)
    return newOrder
  } catch (e) {
    console.error(e)
  }
}

export async function fetchFullOrder(orderId) {
  try {
    const { body: order } = await superagent.get(`${API_PATH}/orders/${orderId}`)
    for (const rental of order.rentals) {
      const { body: productVariation } = await superagent
        .get(`${API_PATH}/product-variations/${rental.product_variation}`)
      rental.product_variation = productVariation
    }
    return order
  } catch (e) {
    console.error(e)
  }
}

export async function postOrder({ skuList, dateFrom, dateTo, deliveryType=null, sessionId }) {
  const { body: order } = await superagent.post(`${API_PATH}/orders`)
    .send({
      skuList,
      dateFrom,
      dateTo,
      meta: {
        origin: window.location.toString(),
        deliveryType,
        sessionId,
      }
    })

  return order
}

export function eventLog(event) {
  superagent.post(`${API_PATH}/event-logs`).send({
    session_id: SESSION_ID,
    page_url: window.location.href, 
    event_data: event,
  }).end();
}